import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import './SignUp.css';

const SignUp = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    // Retrieve existing users from localStorage
    const users = JSON.parse(localStorage.getItem('users')) || [];

    // Check if username or email already exists
    const userExists = users.some(user => user.username.toLowerCase() === username.toLowerCase());
    const emailExists = users.some(user => user.email.toLowerCase() === email.toLowerCase());

    if (userExists) {
      alert("Account already exists");
      setUsername('');
      setEmail('');
      setPassword('');
      return;
    } else if (emailExists) {
      alert("Email already Registered");
      setUsername('');
      setEmail('');
      setPassword('');
      return;
    } else {
      alert('Thank you for signing up! You will be redirected to the login page.');
      const newAccount = { username, email, password };

      // Add new account to users array and save to localStorage
      users.push(newAccount);
      localStorage.setItem('users', JSON.stringify(users));

      navigate("/login");
    }
  };

  return (
    <div className="signupDiv">
      <form className="signupForm" onSubmit={handleSubmit}>
        <h2>Create An Account</h2>
        <br/>
        <div>
          <input
            placeholder="Username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <input
            placeholder="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <input
            placeholder="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Sign Up</button>
      </form>
    </div>
  );
};

export default SignUp;